import { Product, ProductType } from "module/types";
import "sass/components/ColumnGrid.scss";
import { useNavigate } from "react-router-dom";
import { products } from "module/products";
import "sass/components/ThumbnailCardViewGrid.scss";
import { useTranslation } from "react-i18next";

type ThumbnailCardViewGridProps = {
  items: Product[];
  onItemClick?: (id: number, title: string) => void;
};

const ThumbnailCardViewGrid = ({
  items,
  onItemClick,
}: ThumbnailCardViewGridProps) => {
  const { t } = useTranslation();
  let navigate = useNavigate();

  const onClickCell = (id: number) => {
    const product = products.find((p) => p.id === id);
    if (product) {
      onItemClick?.(id, product.title);

      // 1인용 도구들은 직접 게임 페이지로 이동
      if (id === 3) {
        // SingleRoleRoulette
        navigate("/single-role-roulette");
      } else if (id === 4) {
        // TeamBuilder
        navigate("/team-builder");
      } else if (id === 5) {
        // LuckyDraw
        navigate("/lucky-draw");
      } else if (id === 8) {
        // FightSimulator
        navigate("/fight-simulator");
      } else {
        navigate("/room", { state: { product } });
      }
    }
  };

  const renderAttributes = (product: Product) => {
    const commonAttributes =
      product.attributes.maxUsers !== 1 ? (
        <div className="thumbnail-cardview-grid-type-item bg-gray-700">
          {`${product.attributes.minUsers}-${product.attributes.maxUsers} ${t(
            "players"
          )}`}
        </div>
      ) : null;

    if (product.type === ProductType.RECREATION) {
      return (
        <>
          {product.attributes.gameModes?.map((mode, index) => (
            <div
              key={index}
              className="thumbnail-cardview-grid-type-item bg-gray-700"
            >
              {t(mode.toString())}
            </div>
          ))}
          {product.attributes.isCooperative && (
            <div className="thumbnail-cardview-grid-type-item bg-gray-700">
              {t("cooperative")}
            </div>
          )}
          {commonAttributes}
        </>
      );
    } else {
      return <>{commonAttributes}</>;
    }
  };

  return (
    <>
      <div className="thumbnail-cardview-grid-container">
        {items.map((item, index) => (
          <div
            className="thumbnail-cardview-grid-cell"
            key={index}
            onClick={() => onClickCell(item.id)}
          >
            <img
              className="thumbnail-cardview-grid-thumbnail object-contain"
              alt=""
              src={item.thumbnailUrl}
            />
            <div className="thumbnail-cardview-grid-body-container">
              <div className="thumbnail-cardview-grid-title">
                {t(`${item.title}.title`)}
              </div>
              <div className="thumbnail-cardview-grid-subtitle">
                {t(item.shortDescription)}
              </div>
              <div className="thumbnail-cardview-grid-type-list">
                {renderAttributes(item)}
              </div>
              <div className="thumbnail-cardview-grid-view">
                <div className="flex items-center">
                  {t("letsPlay")}
                  <i
                    className="fa-solid fa-arrow-right"
                    style={{ marginLeft: "8px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ThumbnailCardViewGrid;
